<template>
    <div>
      <quill-editor
        v-model="pagecontext"
        ref="myQuillEditor"
        :options="editorOption"
        @change="onEditorChange($event)"
      >
      </quill-editor>
      <el-row style="margin-top: 10px;">
        <el-col :span="24">
          <el-button type="primary" icon="el-icon-edit" @click="savecpms" round>保存</el-button>
        </el-col>
      </el-row>
      <el-dialog width="40%" :title="selectuppathtitle" :visible.sync="visupfilepanel">
        <el-row>
          <el-col :span="12">
            <el-form  label-width="120px">
              <el-form-item label="上传资料" class="yyzz_upload">
                <MUpLoadFile ref="upfile" @upmok="upmok" :ifshowfile="ifshowfile" :ifupload="ifupload" :ifallfile="ifimg" :curfilepath="curfilepath1" bucketpath="ecomm/goodsimg"></MUpLoadFile>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item title="上传说明" name="1">
                <div>1、您可以上传任何类型的资料。</div>
                <div>2、上传前一定要看好上传的路径！</div>
                <div>3、上传时，上传文件下方会有上传进度。</div>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import * as Quill from 'quill'
  import Utils from '../../util/utils'
  import Video from '../../util/video'
  import MUpLoadFile from '../upload/MUpLoadFile'
  import {quillRedefine} from 'vue-quill-editor-upload'
  import {quillEditor} from 'vue-quill-editor'
  var OSS = require('ali-oss')
  Quill.register(Video, true)
  Vue.prototype.$http = axios
  var that
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{ script: 'sub' }, { script: 'super' }],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['link', 'image', 'video'],
    ['clean']
  ]
  export default {
    name: 'GDes',
    components: {quillEditor, quillRedefine,MUpLoadFile},
    data () {
      return {
        viszttype: false,
        iffzsyinfo: '1',
        iffzsy: [{
          value: '1',
          label: '放置'
        }, {
          value: '2',
          label: '不放置'
        }],
        sympageinfo: '',
        visztpage: false,
        newtitle: '',
        newsubtitle: '',
        pagecontext: '',
        selectuppathtitle: '',
        selectpath: '',
        editorOption: {},
        activeName: ['1'],
        files: 100,
        uppercent: 0,
        uploadHeaders: {
          authorization: ''
        },
        visupfilepanel: false,
        ifshowfile:false, // 上传页面参数： 是否显示文件
        curfilepath: '', // 上传页面参数： 当前选中图标文件路径
        curfilepath1: '', // 上传页面参数： 当前选中图标文件路径
        ifimg: true, // 上传页面参数： 上传方式是否设定为 图片模式
        ifupload: false, // 上传页面参数： 是否显示上传参数
        upfiletype: 'image',
        filemodel: 'new',
        selectpageid: '',
        khid: '',
        ifrun: false
      }
    },
    created: function () {
      this.editorOption =
        {
          uploadConfig: {
            methods: 'POST',
            res: (respnse) => {
              console.log(respnse)
              return respnse.info
            }
          },
          methods: 'POST',
          size: 5100,
          accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
          // input点击事件  formData是提交的表单实体
          change: (formData) => {
          },
          // 设置请求头 xhr: 异步请求， formData: 表单对象
          header: (xhr, formData) => {
            // xhr.setRequestHeader('myHeader','myValue');
            // formData.append('token', '1234')
          },
          // start: function (){}
          start: () => {
          },
          end: () => {
          },
          success: () => {
            console.log('上传成功')
          },
          error: () => {
          },
          placeholder: '请在此输入内容',
          theme: 'snow',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function (value) {
                  that.visupfilepanel = true
                  that.selectuppathtitle = '上传图片'
                  that.ifrun = false
                  that.upfiletype = 'image'
                },
                'video': function (value) {
                  that.visupfilepanel = true
                  that.selectuppathtitle = '上传视频'
                  that.upfiletype = 'video'
                }
              }
            }
          }
        }
    },
    mounted: function () {
      that = this
      this.khid = getCookie('cusid')
      that.selectpath = 'ecomm/des/'
      console.log(that)
    },
    methods: {
      lookdes () {
        window.console.log(escape2Html(that.pagecontext))
      },
      querygoodsdes () {
        var qstr = {
          whereinfo: 'goods_id = ' + localStorage.getItem('curgoodsid') + "' and ownphone='" + localStorage.getItem('username') + "'",
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querygdes',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.length > 0) {
              var cuszl = res.data
              console.log(cuszl)
              that.pagecontext = cuszl[0].des.String
            } else {
              that.pagecontext = ''
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      savecpms () {
        console.log(this.pagecontext)
        var adata
        adata = {
          goods_id: localStorage.getItem('curgoodsid').toString(),
          des: this.pagecontext,
          cusid: that.khid.toString(),
          ownphone: localStorage.getItem('username')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addgdes',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$options.methods.querygoodsdes()
              localStorage.setItem('newgdes',that.pagecontext)
              that.$message({
                type: 'success',
                message: '保存描述成功!'
              })
              that.$emit('reloaddata');
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      preaimg () {
        that.$emit('preaimg');
      },
      upmok (curpath,fileList) {
        window.console.log('执行写入图片')
        window.console.log(curpath)
        window.console.log('文件列表',fileList,fileList[0].name)

        if (this.upfiletype === 'image') {
          if (!that.ifrun) {
            for (var i=0; i < fileList.length; i++) {
              window.console.log(fileList[i])
              this.pagecontext = this.pagecontext + '<p><img src="http://sqtech.oss-cn-beijing.aliyuncs.com/ecomm/goodsimg/' + fileList[i].name + '"></p>'
            }
            that.ifrun = true
          }
        } else if (this.upfiletype === 'video') {
          this.pagecontext = this.pagecontext + '<p> 增加的视频资料 '
          this.pagecontext = this.pagecontext + '<p><video class="videoinfo" id="videoinfo" src="' + curpath + '" controls="controls" loop="loop"> </video></p>'
          this.pagecontext = this.pagecontext + '</p>'
        }
      },
      OnUpFileSuccess (res, file, fileList) {
        if (res.success) {
          if (this.upfiletype === 'image') {
            this.pagecontext = this.pagecontext + '<p><img src="' + res.data[0].osspath + '"></p>'
          } else if (this.upfiletype === 'video') {
            this.pagecontext = this.pagecontext + '<p> 增加的视频资料 '
            this.pagecontext = this.pagecontext + '<p><video class="videoinfo" id="videoinfo" src="' + res.data[0].osspath + '" controls="controls" loop="loop"> </video></p>'
            this.pagecontext = this.pagecontext + '</p>'
          }
        }
      },
      OnUpFileError (res) {},
      BeforeUpFileUpload (file) {},
      onEditorChange ({editor, html, text}) {
        console.log('---内容改变事件---')
        console.log(html)
      },
      randomString (num) {
        let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        let res = ''
        for (let i = 0; i < num; i++) {
          var id = Math.ceil(Math.random() * 35)
          res += chars[id]
        }
        return res
      },

      /**
       * 创建oss客户端对象
       * @returns {*}
       */
      createOssClient () {
        return new Promise((resolve, reject) => {
          let client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: 'LTAIaf73dyK72dHv',
            accessKeySecret: 'GRv2JMOvMC02F402r2ZHBElebVUB9v',
            bucket: 'sqpro'
          })
          resolve(client)
        })
      },
      /**
       * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
       * @author   yangxiaoshuo
       * @param    {object}   option [上传选项]
       * @return   {null}   [没有返回]
       */
      async fnUploadRequest (option) {
        var that = this
        let file = option.file
        const self = this
        return new Promise((resolve, reject) => {
          let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
          console.log(date)
          let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
          let randomStr = self.randomString(4)//  4位随机字符串
          let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
          console.log(dateTime)
          console.log(randomStr)
          console.log(extensionName)
          let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
          // 执行上传
          self.createOssClient().then(client => {
            // 异步上传,返回数据
            resolve({
              fileName: file.name,
              fileUrl: fileName
            })
            // 上传处理
            // 分片上传文件
            client.multipartUpload(fileName, file, {
              progress: function (p) {
                let e = {}
                e.percent = Math.floor(p * 100)
                // console.log('Progress: ' + p)
                option.onProgress(e)
                that.uppercent = e.percent
                console.log(e.percent)
              }
            }).then((val) => {
              if (val.res.statusCode === 200) {
                option.onSuccess(val)
                return val
              } else {
                option.onError('上传失败')
              }
            }, err => {
              option.onError('上传失败')
              reject(err)
            })
          }).catch(errinfo => {
          })
        })
      },
      /**
       * @description [fnUploadSuccess 文件上传成功的函数]
       * @author   shanshuizinong
       * @return   {null}  [没有返回]
       */
      async fnUploadSuccess (res, file, fileList) {
        console.log(res)
        if (res.res.status === 200) {
          var uppath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
          console.log(uppath)
          console.log(this.upfiletype)
          if (this.upfiletype === 'image') {
            this.pagecontext = this.pagecontext + '<p><img src="' + uppath + '"></p>'
          } else {
            this.pagecontext = this.pagecontext + '<video class="videoinfo" id="videoinfo" src="' + uppath + '" controls="controls" loop="loop"> </video>'
          }
          console.log(this.pagecontext)
        }
        // TODO
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
  function escape2Html (str) {
    var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
    var strtmp = str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];})
    return strtmp
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/newgoods/GDes.vue